import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateLanguageConfigurationRPC } from "./updateLanguageConfigurationRPC";

export class UpdateLanguageConfigurationRPCClientImpl extends UpdateLanguageConfigurationRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateLanguageConfigurationRPC.Request): Promise<LeoRPCResult<UpdateLanguageConfigurationRPC.Response, UpdateLanguageConfigurationRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/UpdateLanguageConfiguration",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateLanguageConfigurationRPC.ResponseDTO,
      UpdateLanguageConfigurationRPC.Errors.ErrorsDTO,
      UpdateLanguageConfigurationRPC.Response,
      UpdateLanguageConfigurationRPC.Errors.Errors
    >(
      response,
      "survey/UpdateLanguageConfiguration",
      UpdateLanguageConfigurationRPC.Response.fromDTO,
      UpdateLanguageConfigurationRPC.Errors.fromDTO
    );
  }
}
